import intlTelInput from "intl-tel-input/intlTelInputWithUtils";

const formatPhoneNumber = (phoneNumber: string): string => {
  if (phoneNumber.startsWith("+") && intlTelInput.utils) {
    return intlTelInput.utils.formatNumber(
      phoneNumber,
      undefined,
      intlTelInput.utils.numberFormat.INTERNATIONAL,
    );
  }

  return phoneNumber;
};

export default formatPhoneNumber;
